export default __webpack_public_path__ + "static/media/Gauntlets of Bloodlust.a7e3b505.jpg";